import { Outlet, Link, useLocation } from 'react-router-dom'
import { LayoutDashboard, Users, ClipboardList, Rocket, MessageSquare, UsersRound, Activity, Settings, History, Code, Clock } from 'lucide-react'

const navItems = [
  { icon: LayoutDashboard, label: 'Dashboard', path: '/' },
  { icon: Users, label: 'Agents', path: '/agents' },
  { icon: UsersRound, label: 'Agent Team', path: '/team' },
  { icon: Clock, label: 'Long Task', path: '/long-running-task' },
  { icon: ClipboardList, label: 'Tasks', path: '/tasks' },
  { icon: History, label: 'Workflow History', path: '/history' },
  { icon: Code, label: 'Code Viewer', path: '/code-viewer' },
  { icon: MessageSquare, label: 'AI Chat', path: '/chat' },
  { icon: Rocket, label: 'Deployments', path: '/deployments' },
  { icon: Activity, label: 'Monitor', path: '/monitor' },
  { icon: Settings, label: 'Settings', path: '/settings' }
]

export default function Layout() {
  const location = useLocation()

  return (
    <div className="min-h-screen bg-gray-900">
      <aside className="fixed inset-y-0 left-0 w-64 bg-gray-800 border-r border-gray-700">
        <div className="p-6">
          <h1 className="text-xl font-bold text-orange-500">CF Agent Platform</h1>
          <p className="text-sm text-gray-400 mt-1">智能体自动编程部署</p>
        </div>
        
        <nav className="mt-6">
          {navItems.map(({ icon: Icon, label, path }) => (
            <Link
              key={path}
              to={path}
              className={`flex items-center px-6 py-3 text-sm transition-colors ${
                location.pathname === path
                  ? 'bg-gray-700 text-orange-500 border-r-2 border-orange-500'
                  : 'text-gray-300 hover:bg-gray-700 hover:text-white'
              }`}
            >
              <Icon className="w-5 h-5 mr-3" />
              {label}
            </Link>
          ))}
        </nav>
      </aside>

      <main className="ml-64 p-8">
        <Outlet />
      </main>
    </div>
  )
}
